import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export interface WorldCupStandingsModalStyleOptions {
  safeAreaTop?: number;
}

export const getWorldCupStandingsModalStyles = (
  theme: Theme,
  options?: WorldCupStandingsModalStyleOptions,
) => {
  const safeAreaTop = options?.safeAreaTop ?? 0;
  return StyleSheet.create({
    fullScreen: {
      flex: 1,
      width: '100%',
      backgroundColor: theme.background.primary,
      ...(Platform.OS === 'web' && {
        maxHeight: '100vh' as never,
      }),
    },
    header: {
      paddingTop: Math.max(safeAreaTop, 10),
      paddingHorizontal: 16,
      paddingBottom: 4,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
      backgroundColor: theme.background.primary,
    },
    titleRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: 4,
      marginBottom: 8,
    },
    title: {
      fontSize: 15,
      fontWeight: '800',
      letterSpacing: 2,
      color: theme.gray[800],
    },
    closeButton: {
      width: 38,
      height: 38,
      borderRadius: 8,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.background.card,
      borderWidth: 1,
      borderColor: theme.gray[300],
    },
    closeButtonPressed: {
      opacity: 0.7,
    },
    closeButtonHover: {
      opacity: 0.85,
    },
    tabBar: {
      marginTop: 4,
    },
    tabRow: {
      flexDirection: 'row',
    },
    tabButton: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      paddingBottom: 10,
    },
    tabButtonPressed: {
      opacity: 0.75,
    },
    tabButtonHoverInactive: {
      opacity: 0.9,
    },
    tabLabel: {
      fontSize: 13,
      fontWeight: '700',
    },
    tabLabelActive: {
      color: theme.primary,
    },
    tabLabelInactive: {
      color: theme.gray[500],
    },
    tabUnderlineTrack: {
      height: 2,
      position: 'relative',
      flexDirection: 'row',
    },
    tabUnderline: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      width: '50%',
      height: 2,
      borderRadius: 2,
      backgroundColor: theme.primary,
    },
    tabUnderlineRight: {
      left: '50%',
    },
    scroll: {
      flex: 1,
    },
    scrollContent: {
      paddingHorizontal: 16,
      paddingTop: 16,
      paddingBottom: 32,
    },
    groupsSectionTitle: {
      fontSize: 15,
      fontWeight: '800',
      letterSpacing: 1.8,
      color: theme.gray[800],
      marginBottom: 10,
    },
    stateWrap: {
      paddingVertical: 48,
      paddingHorizontal: 20,
      alignItems: 'center',
      justifyContent: 'center',
    },
    stateTitle: {
      marginTop: 16,
      fontSize: 16,
      fontWeight: '700',
      color: theme.gray[800],
      textAlign: 'center',
    },
    stateSubtitle: {
      marginTop: 8,
      fontSize: 14,
      fontWeight: '500',
      color: theme.gray[600],
      textAlign: 'center',
      lineHeight: 21,
    },
    knockoutPlaceholder: {
      paddingVertical: 48,
      paddingHorizontal: 20,
      alignItems: 'center',
    },
    knockoutText: {
      marginTop: 16,
      fontSize: 15,
      fontWeight: '600',
      color: theme.gray[600],
      textAlign: 'center',
      lineHeight: 22,
    },
    footnote: {
      marginTop: 8,
      fontSize: 12,
      fontWeight: '500',
      color: theme.gray[500],
      textAlign: 'center',
      lineHeight: 18,
    },
  });
};
